const valuePropCarousel = {
  displayField: 'internalName',
  name: 'Value Prop Carousel',
  description: '',
  fields: [
    {
      id: 'internalName',
      name: 'Internal Name',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'eyebrow',
      name: 'Eyebrow',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'header',
      name: 'Header',
      type: 'Symbol',
      localized: true,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'backgroundColor',
      name: 'Background color',
      type: 'Boolean',
      localized: false,
      required: true,
      validations: [],
      defaultValue: { 'en-US': true },
      disabled: false,
      omitted: false
    },
    {
      id: 'valuePropCardContent',
      name: 'Value Prop Card Content',
      type: 'Array',
      localized: false,
      required: true,
      validations: [],
      disabled: false,
      omitted: false,
      items: { type: 'Link', validations: [], linkType: 'Entry' }
    }
  ],
  sys: {
    id: 'valuePropCarousel',
    version: 12,
    updatedAt: '2023-07-26T15:52:41.245Z'
  }
};
export default valuePropCarousel;